"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcPlaceLabel = void 0;
const commaJoin_1 = __importDefault(require("@opsbase/lib-general/utils/commaJoin"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
function calcPlaceLabel(opSchedule) {
    var _a, _b;
    if (opSchedule.placesSelectedByTag) {
        return 'All places tagged with ' + (0, commaJoin_1.default)(opSchedule.placeTags, 'or');
    }
    else if (opSchedule.placesSelectedByParent && ((_a = opSchedule.places) === null || _a === void 0 ? void 0 : _a.length)) {
        return ('Any places within ' +
            (0, commaJoin_1.default)(opSchedule.places.map(p => p.title), 'or'));
    }
    else if ((_b = opSchedule.places) === null || _b === void 0 ? void 0 : _b.length) {
        return (0, commaJoin_1.default)(opSchedule.places.map(p => p.title), 'or');
    }
    else {
        return lib_i18n_1.default.t('all-permitted-places');
    }
}
exports.calcPlaceLabel = calcPlaceLabel;
exports.default = calcPlaceLabel;
